import PropTypes from 'prop-types';
import {
  FormField,
} from '@codev/helix-react';
import React from 'react';
import {
  Col,
  FormControl,
  Grid,
  Row,
} from 'react-bootstrap';
import Captcha from '../Captcha.jsx';
import languagesPropType from '../languagesPropType.js';
import styles from './styles.css';
import translate from './translate.js';

const EmailAddressForm = ({
  captchaSiteKey,
  email,
  language,
  onChange,
  onSubmit,
}) => (
  <Grid
    className={styles.grid}
    fluid
  >
    <Row style={{textAlign: 'center'}}>
      <Col xs={12}>
        <span style={{fontSize: '18px'}}>{translate('enterEmailAddress', language)}</span>
      </Col>
    </Row>

    <Row style={{marginTop: '20px', textAlign: 'center'}}>
      <Col xs={12}>
        <div style={{fontSize: '16px', fontWeight: 400}}>{translate('submitEmailAddress', language)}</div>
      </Col>
    </Row>

    <Row style={{marginTop: '20px'}}>
      <Col xs={12}>
        <FormField
          isRequired
          isRequiredErrorMessage={translate('emailAddressRequiredMessage', language)}
          label={translate('emailAddress', language)}
          style={{marginLeft: 'auto', marginRight: 'auto', width: '320px'}}
          value={email}
        >
          <FormControl
            autoFocus
            name='email'
            onChange={onChange}
            placeholder="example@example.com"
            value={email}
          />
          <div className={styles.note}>
            {translate('passwordRequestLimit', language)}
          </div>
        </FormField>
        <Captcha
          callback={onSubmit}
          siteKey={captchaSiteKey}
        />
      </Col>
    </Row>
  </Grid>
);

EmailAddressForm.defaultProps = {
  language: languagesPropType.defaultProp,
};

EmailAddressForm.propTypes = {
  captchaSiteKey: PropTypes.string,
  email: PropTypes.string,
  language: languagesPropType.propType,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default EmailAddressForm;
